namespace GeniuzPOS.Inventory {
    export interface IcStockApproveHdRow {
        Id?: number;
        SysDocNo?: string;
        StockCountCode?: string;
        StockCountDesc?: string;
        StockCountDate?: string;
        RefDocNo?: string;
        WhsId?: string;
        WhsName?: string;
        Remark?: string;
        ApproveFg?: ApproveFgSelect;
        PostFg?: PostFgStatus;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        IcStockCountTranList?: IcStockApproveDtRow[];
        ApproveBy?: string;
        ApproveDate?: string;
        PostDate?: string;
        CancelFg?: CancelFgstatus;
    }

    export namespace IcStockApproveHdRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'StockCountCode';
        export const localTextPrefix = 'Inventory.IcStockApproveHd';
        export const lookupKey = 'Inventory.IcStockApproveHd';

        export function getLookup(): Q.Lookup<IcStockApproveHdRow> {
            return Q.getLookup<IcStockApproveHdRow>('Inventory.IcStockApproveHd');
        }
        export const deletePermission = '2Inventory:ตรวจนับ:อนุมัติ:Modify';
        export const insertPermission = '2Inventory:ตรวจนับ:อนุมัติ:Modify';
        export const readPermission = '2Inventory:ตรวจนับ:อนุมัติ:View';
        export const updatePermission = '2Inventory:ตรวจนับ:อนุมัติ:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            StockCountCode = "StockCountCode",
            StockCountDesc = "StockCountDesc",
            StockCountDate = "StockCountDate",
            RefDocNo = "RefDocNo",
            WhsId = "WhsId",
            WhsName = "WhsName",
            Remark = "Remark",
            ApproveFg = "ApproveFg",
            PostFg = "PostFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            IcStockCountTranList = "IcStockCountTranList",
            ApproveBy = "ApproveBy",
            ApproveDate = "ApproveDate",
            PostDate = "PostDate",
            CancelFg = "CancelFg"
        }
    }
}
